import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { RoutesEnum } from '~/constants/enums';

export default function AuthButtons() {
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  return (
    <>
      <Button
        variant="primary"
        size="medium"
        onClick={() => {
          window.location.replace(
            `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.LOGIN}`,
          );
        }}
        className="w-full md:w-[171px]"
      >
        {t('login')}
      </Button>
      <Button
        variant="tertiary"
        size="medium"
        onClick={() => {
          window.location.replace(
            `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.REGISTER}`,
          );
        }}
        className="w-full md:w-[171px]"
      >
        {t('createAccount')}
      </Button>
    </>
  );
}
